import { render, staticRenderFns } from "./block-image2.vue?vue&type=template&id=523d7f1d"
import script from "./block-image2.vue?vue&type=script&lang=js"
export * from "./block-image2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports